import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { initClarity } from '../utils/clarity';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FormCTASection } from '../components/FormCTASection';
import { CTASection } from '../components/CTASection';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
    initClarity();
  }, []);
  return <div className="min-h-screen bg-brand-black selection:bg-brand-gold selection:text-brand-black font-sans" data-id="element-198">
      <main data-id="element-199">
        <HeroSection data-id="element-200" />
        <PainSection data-id="element-201" />
        <SolutionSection data-id="element-202" />
        <TestimonialsSection data-id="element-203" />
        <GuaranteeSection data-id="element-204" />
        <UrgencySection data-id="element-205" />
        <FormCTASection data-id="element-206" />
        <CTASection data-id="element-207" />
      </main>

      <footer className="bg-[#050505] py-10 text-center text-brand-lightGray/50 text-sm px-6 border-t border-white/5" data-id="element-208">
        <div className="max-w-[900px] mx-auto space-y-4" data-id="element-209">
          <p data-id="element-210">
            © {new Date().getFullYear()} Final Expense Protection. Todos los
            derechos reservados.
          </p>
          <p className="text-xs max-w-2xl mx-auto" data-id="element-211">
            La disponibilidad y los beneficios pueden variar según el estado.
            Esta es una solicitud de seguro. Al enviar su información, usted
            acepta ser contactado por un agente de seguros autorizado.
          </p>
        </div>
      </footer>
    </div>;
}